import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-69100e60")

_pushScopeId("data-v-69100e60")
const _hoisted_1 = { class: "mobile-download" }
const _hoisted_2 = { class: "download-wrap" }
const _hoisted_3 = {
  key: 0,
  class: "background-wrap"
}
const _hoisted_4 = { class: "background-text" }
const _hoisted_5 = {
  key: 1,
  class: "file-wrap"
}
const _hoisted_6 = { class: "button-wrap" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DownloadedFiles = _resolveComponent("DownloadedFiles")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.isEmpty)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode("img", {
              class: "background-image",
              src: require('../../assets/images/no-attach-files-background.png')
            }, null, 8, ["src"]),
            _createVNode("p", _hoisted_4, _toDisplayString(_ctx.t('fileInput.noFiles')), 1)
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_5, [
            _createVNode(_component_DownloadedFiles, { class: "mobile-file" })
          ]))
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode(_component_Button, {
        class: "button-download",
        mode: "primary",
        size: "l",
        onClick: _ctx.closeDrawer
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.t('fileInput.title')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
})